<template>
  <div
    class="rounded-box"
    :style="'background-color:' + bgColor + '; height:' + height"
  >
    <div style="display: flex">
      <slot name="title">
        <p
          class="h6"
          v-if="!!title"
          :style="'color:' + titleColor + '!important'"
        >
          <strong> {{ title }}</strong>
        </p>
      </slot>
      <v-spacer v-if="!!titleEnd" />
      <slot name="title-end">
        <p
          class="h6 text-right"
          v-if="!!titleEnd"
          :style="'color:' + titleColor + '!important'"
        >
          <strong> {{ titleEnd }}</strong>
        </p>
      </slot>
    </div>
    <slot>
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
        class="d-flex align-center justify-center"
      ></v-progress-circular>
      <p
        class="h4"
        v-if="!loading && !!value"
        :style="
          'color:' + valueColor + '!important; bottom: 0rem; position: absolute'
        "
      >
        {{ value }}
      </p></slot
    >
  </div>
</template>

<script>
export default {
  name: "RoundedBox",
  props: {
    title: {
      type: String,
      default: "",
    },
    titleEnd: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "#ffffffcc",
    },
    titleColor: {
      type: String,
      default: "#000",
    },
    valueColor: {
      type: String,
      default: "#000",
    },
    height: {
      type: String,
      default: "auto",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>